<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link :to="{ path: BACKEND_URL + '/addresses/edit/' + address.id, props: { id: address.id } }" v-if="$can('address-edit')">
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(address.id)" v-if="$can('address-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="address.street"
                  v-model="address.street"
                  :label="$t('addresses.street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="address.zip"
                  v-model="address.zip"
                  :label="$t('addresses.zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="address.city"
                  v-model="address.city"
                  :label="$t('addresses.city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="address.state"
                  v-model="address.state"
                  :label="$t('addresses.state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="address.country"
                  :value="this.$dd_countries(address.country)"
                  :label="$t('addresses.country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TaskView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      address: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "address/" + this.id)
      .then((res) => {
        this.address = res.data.data
        this.page_title = this.$t("addresses.view_address", { name: this.address.title })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "address/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/addresses")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
